import { render, staticRenderFns } from "./VendorPayment.vue?vue&type=template&id=6320decf"
import script from "./VendorPayment.vue?vue&type=script&lang=js"
export * from "./VendorPayment.vue?vue&type=script&lang=js"
import style0 from "./VendorPayment.vue?vue&type=style&index=0&id=6320decf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports